export default __webpack_public_path__ + "static/media/img_2.325c0388.jpg";